/**
 * Open the browser print dialog. iOS in-app browsers (WKWebView) throw on
 * `window.print()` because `webkit.messageHandlers.print` is missing.
 */
export function printPage(): void {
  try {
    window.print();
  } catch {
    // Print is unavailable in this WebView; ignore so the click is not an error.
  }
}
